import React, { useState, useEffect } from "react";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import moment from 'moment';

import { CustomDatePicker } from "../mui_components/muiComponents";
import "date-fns";

function DateInputComponent({
  title,
  label,
  placeholder,
  width,
  disableFuture,
  disabled,
  formData,
  setFormData,
  dataEntries,
  setDataEntries,
  error,
  subscription
}) {

  let dataEntriesFromLocalStorage = JSON.parse(localStorage.getItem("dataEntriesInLocal"));

  const initialStartDate = dataEntriesFromLocalStorage["Start Date *"];
  // console.log('initial start date', initialStartDate);
  const myMomentObject = moment(initialStartDate, 'YYYY-MM-DD');
  // console.log('string to date', myMomentObject);

  const dateAfterFourDays = moment(myMomentObject).add(5, 'days').format('YYYY-MM-DD');
  // console.log('after four days', dateAfterFourDays);


  const endDate = dataEntriesFromLocalStorage["End Date *"];
  // console.log('endDate', endDate, typeof endDate);

  const [dateInp, setDateInp] = useState(null);

  // console.log('default date', dateInp);
  // console.log('disableFuture disableFuture', disableFuture);

  const dateChange = (id, e) => {

    if (e) {
      setDateInp(e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate());
      let formattedDate = e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate();
      let obj = { ...formData, [id]: formattedDate };

      let obj1 = { ...dataEntriesFromLocalStorage, [id]: formattedDate };
      setFormData(obj);
      setDataEntries(obj1);
      localStorage.setItem("dataEntriesInLocal", JSON.stringify(obj1));
    }

  };

  useEffect(() => {
    setDateInp(null);
    let obj = { ...formData, ['End Date']: undefined };

    let obj1 = { ...dataEntriesFromLocalStorage, ['End Date']: undefined };
    setFormData(obj);
    setDataEntries(obj1);
    localStorage.setItem("dataEntriesInLocal", JSON.stringify(obj1));

  }, [dataEntriesFromLocalStorage["Start Date *"]]);


  // console.log('start date', dataEntriesFromLocalStorage["Start Date *"]);

  return (
    <div style={{ width: width ? width : "100%" }} >

      <MuiPickersUtilsProvider utils={DateFnsUtils} fullWidth>

        {placeholder == "Start Date *" ?

          <CustomDatePicker
            inputVariant="outlined"
            fullWidth
            minDate={new Date()}
            variant="dialog"
            format="dd-MM-yyyy"
            openTo="year"
            label={title}
            placeholder={placeholder ? title : ""}
            value={
              dataEntriesFromLocalStorage[placeholder]
                ? dataEntriesFromLocalStorage[placeholder]
                : null
            }
            disabled={disabled ? disabled : false}
            onChange={(e, v) => dateChange(placeholder, e, v)}
            error={
              typeof error === "object" && Object.keys(error).length ? true : false
            }
            helperText={
              typeof error === "object" && Object.keys(error).length ? (
                <>
                  {Object.keys(error).map((item, index) => {
                    return (
                      <span className="text-danger fs14px" key={index}>{error[item]}</span>
                    );
                  })}
                </>
              ) : null
            }
          />

          :

          <CustomDatePicker
            inputVariant="outlined"
            fullWidth
            minDate={initialStartDate ? dateAfterFourDays : new Date()}
            variant="dialog"
            format="dd-MM-yyyy"
            openTo="date"
            label={title}
            placeholder={placeholder ? title : ""}
            value={
              dataEntriesFromLocalStorage[placeholder]
                ? dataEntriesFromLocalStorage[placeholder]
                : dateInp
            }
            // disabled={disabled ? disabled : false}
            disabled={dataEntriesFromLocalStorage["Start Date *"] === "" ? true : false}
            onChange={(e, v) => dateChange(placeholder, e, v)}
            error={
              typeof error === "object" && Object.keys(error).length ? true : false
            }
            helperText={
              typeof error === "object" && Object.keys(error).length ? (
                <>
                  {Object.keys(error).map((item, index) => {
                    return (
                      <span className="text-danger fs14px" key={index}>{error[item]}</span>
                    );
                  })}
                </>
              ) : null
            }
          />

        }


      </MuiPickersUtilsProvider>
    </div>
  );
}

export default DateInputComponent;
